import React, {Component} from 'react';
import Swiper from 'react-id-swiper';

class ServiceGridSlider extends Component{
    render(){
        const params = {
            slidesPerView : 3,
            loop: true,
            speed: 1000,
            watchSlidesVisibility: true,
            spaceBetween : 30,
            autoplay: {
                delay: 3000,
            },
            // Responsive breakpoints
            breakpoints: {
                1499:{
                    slidesPerView : 3
                },

                991:{
                    slidesPerView : 2
                },

                767:{
                    slidesPerView : 1

                },

                575:{
                    slidesPerView : 1
                }
            }

        }
        let data = [
            {img: 'service1.jpg', iconName: 'fa fa-graduation-cap', serviceTitle: 'Early Intervention & Child Development', serviceExcerpt: 'Supporting young children through early intervention to promote physical, cognitive, language, social, and emotional development.', serviceUrl: 'services'},
            {img: 'service2.jpg', iconName: 'fa fa-heart', serviceTitle: 'Play & Language Therapy', serviceExcerpt: 'Play and language therapy use play-based activities and structured communication exercises to improve children’s speech, language, social, emotional, and cognitive skills, promoting overall development and effective communication.', serviceUrl: 'services'},
            {img: 'service3.jpg', iconName: 'fa fa-comments', serviceTitle: 'Social Communication & Behaviour Modification', serviceExcerpt: 'Helping children develop effective communication, positive behaviour, social skills, emotional regulation, and confidence through evidence-based interventions that support success at home, school, and in the community.', serviceUrl: 'services'},
            {img: 'service4.jpg', iconName: 'fa fa-hand-paper-o', serviceTitle: 'Speech Therapy', serviceExcerpt: 'Speech Therapy helps children develop clear speech, effective communication, language understanding, and confidence through individualized interventions that support learning, social interaction, and successful participation in everyday activities.', serviceUrl: 'services'},
            {img: 'service5.jpg', iconName: 'fa fa-users', serviceTitle: 'Special Education', serviceExcerpt: 'At Shakuntla Learn and Fly Foundation, we provide individualized Special Education programs that empower children with diverse learning needs to achieve academic success, independence, confidence, and lifelong growth.', serviceUrl: 'services'},
            {img: 'service6.jpg', iconName: 'fa fa-child', serviceTitle: 'Learning Support', serviceExcerpt: 'Helping children overcome learning challenges through personalized educational support, building academic skills, confidence, independence, and a positive attitude towards lifelong learning.', serviceUrl: 'services'},
            {img: 'service7.jpg', iconName: 'fa fa-user-md', serviceTitle: 'Occupational Therapy', serviceExcerpt: 'Helping children develop the skills needed for everyday activities by improving motor abilities, sensory processing, coordination, independence, and confidence through individualized, evidence-based therapeutic interventions.', serviceUrl: 'services'},
            {img: 'service8.jpg', iconName: 'fa fa-book', serviceTitle: 'Parent Counselling & Guidance', serviceExcerpt: 'Supporting parents with professional guidance, practical strategies, and emotional support to better understand their child’s needs, strengthen family relationships, and promote positive developmental outcomes.', serviceUrl: 'services'},
            {img: 'service9.jpg', iconName: 'fa fa-book', serviceTitle: 'Holistic Child Development', serviceExcerpt: 'Nurturing every aspect of a child’s growth through integrated programs that support cognitive, physical, emotional, social, communication, and life skills for overall development and lifelong success.', serviceUrl: 'services'},
            {img: 'service10.jpg', iconName: 'fa fa-book', serviceTitle:'Sports Program for Development', serviceExcerpt: 'Promoting physical fitness, teamwork, confidence, coordination, discipline, and social development through structured sports activities that inspire children to lead active, healthy, and confident lives.', serviceUrl: 'services'},
        ];

        let DataList = data.map((val, i)=>{
            return(
                <div className="swiper-slide" key={i}>
                    <div className="service-grid-item">
                    <div className="service-grid-item__image">
                        <div className="service-grid-item__image-wrapper">
                        <a href={`${process.env.PUBLIC_URL}/${val.serviceUrl}`}>
                            <img src={`assets/img/service/${val.img}`} className="img-fluid" alt="" />
                        </a>
                        </div>
                        <div className="icon">
                        <i className={val.iconName} />
                        </div>
                    </div>
                    <div className="service-grid-item__content">
                        <h3 className="title">
                        <a href={`${process.env.PUBLIC_URL}/${val.serviceUrl}`}>{val.serviceTitle}</a>
                        </h3>
                        <p className="subtitle">{val.serviceExcerpt}</p>
                        
                    </div>
                    </div>
                </div>
            )
        });
        return(
            <div>
                {/*====================  service grid slider area ====================*/}
                <div className="service-grid-slider-area section-space--inner--120">
                <div className="container">
                    <div className="row">
                    <div className="col-lg-12">
                        <div className="section-title-area text-center">
                        <h2 className="section-title section-space--bottom--50">Our Services <span className="title-icon" /></h2>
                        </div>
                    </div>
                    <div className="col-lg-12">
                        <div className="service-slider">
                            <Swiper {...params}>
                                {DataList}
                            </Swiper>
                        </div>
                    </div>
                    </div>
                </div>
                </div>
                {/*====================  End of service grid slider area  ====================*/}

            </div>
        )
    }
}


export default ServiceGridSlider;